import type { GuestExportRow } from './apiHelpers';

const CSV_FORMULA_ESCAPE_PREFIX = "'";
const CSV_FORMULA_START_PATTERN = /^[=+\-@\t\r\n＝＋－＠]/;

export const GUEST_EXPORT_COLUMNS = [
  {
    header: 'Guest first name',
    value: (row: GuestExportRow) => row.firstName,
  },
  {
    header: 'Guest last name',
    value: (row: GuestExportRow) => row.lastName,
  },
  {
    header: 'Restaurant name',
    value: (row: GuestExportRow) => row.restaurantName,
  },
  {
    header: 'Guest count for last reservation',
    value: (row: GuestExportRow) => row.guestCountForLastReservation,
  },
  {
    header: 'Most recent table selection',
    value: (row: GuestExportRow) => row.mostRecentTableSelection,
  },
  {
    header: 'Email',
    value: (row: GuestExportRow) => row.email,
  },
  {
    header: 'Phone',
    value: (row: GuestExportRow) => row.phone,
  },
  {
    header: 'Reservation notes',
    value: (row: GuestExportRow) => row.reservationNotes,
  },
  {
    header: 'Guest notes',
    value: (row: GuestExportRow) => row.guestNotes,
  },
  {
    header: 'Restaurant notes',
    value: (row: GuestExportRow) => row.restaurantNotes,
  },
  {
    header: 'Guest tags',
    value: (row: GuestExportRow) => row.guestTags.join('; '),
  },
  {
    header: 'Number of total visits',
    value: (row: GuestExportRow) => row.numberOfTotalVisits,
  },
  {
    header: 'Guest spend',
    value: (row: GuestExportRow) => (row.guestSpend / 100).toFixed(2),
  },
  {
    header: 'First reservation',
    value: (row: GuestExportRow) => row.firstReservation,
  },
  {
    header: 'Last reservation',
    value: (row: GuestExportRow) => row.lastReservation,
  },
];

export const downloadGuestExportCsv = (rows: GuestExportRow[]) => {
  const csv = [
    GUEST_EXPORT_COLUMNS.map((column) => csvEscape(column.header)).join(','),
    ...rows.map((row) =>
      GUEST_EXPORT_COLUMNS.map((column) => csvEscape(column.value(row))).join(
        ',',
      ),
    ),
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = `guest-book-export-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};

export const csvEscape = (value: string | number | null): string => {
  if (value === null) {
    return '';
  }

  const stringValue = String(value);
  const safeStringValue = CSV_FORMULA_START_PATTERN.test(stringValue)
    ? `${CSV_FORMULA_ESCAPE_PREFIX}${stringValue}`
    : stringValue;

  return `"${safeStringValue.replaceAll('"', '""')}"`;
};
